import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';

@Component({
  selector: 'app-confirm-delete',
  templateUrl: './confirm-delete.component.html',
  styleUrls: ['./confirm-delete.component.scss']
})
export class ConfirmDeleteComponent implements OnInit {

  // Título da janela modal
  title: string;
  // Mensagem para confirmação
  text: string;
  // Alguma mensagem extra, se necessária
  extraText: string;
  // A mensagem extra deve ser "null" senão houver alguma

  constructor(
      private dialogRef: MatDialogRef<ConfirmDeleteComponent>, 
      @Inject(MAT_DIALOG_DATA) public data: any) {

    this.title = data.title;
    this.text = data.message;
    this.extraText = data.extraMessage;
  }

  ngOnInit() {
  }

  /**
   * Método chamado na resposta "Sim" do modal.
   *
   * @returns Retorna o boolean "true", indicando que o valor escolhido foi "Sim"
   */
  acceptChange() {
    this.dialogRef.close(true);
  }
}

